import React from 'react';
import RegisterScreen from '@/pages/Tooling/RegisterScreen';
import { PLATE } from '@/pages/Tooling/toolings';

export default function PlateRegisterPage() {
  return <RegisterScreen tooling={PLATE} />;
}
